import { render } from "./Pagination.vue?vue&type=template&id=028ce02b"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=028ce02b&lang=scss"

import exportComponent from "/opt/build/repo/access-trucks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__